import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const mtsInvest1 = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img1.png',
            crewItemTitle: 'Анастасия Андронова',
            crewItemSubtitle: 'руководитель подразделения Вебпрактик.Маркетинг ',
        },
        {
            crewItemImg: '/images/svg/skolkovo/ace-ventura.jpg',
            crewItemTitle: 'Мария Муштатова',
            crewItemSubtitle: 'старший менеджер проектов',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Вадим Шапошников',
            crewItemSubtitle: 'руководитель отдела SEO',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Сидоров',
            crewItemSubtitle: 'SEO-старший специалист',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Рахманин',
            crewItemSubtitle: 'SEO-специалист',
        },
    ],
};

const mtsInvest2 = {
    crewTitle: 'МТС Инвестиции',
    crewSubtitle: 'Выражаем благодарность команде МТС за&nbsp;помощь в&nbsp;работе над проектом:',
    crewList: [
        {
            crewItemImg: null,
            crewItemTitle: 'Михаил Чернышов',
            crewItemSubtitle: 'руководитель проекта',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Никита Рахманинов ',
            crewItemSubtitle: 'руководитель блока развития бизнеса',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Татьяна Акованцева',
            crewItemSubtitle: 'PR-менеджер',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
                <FullWrapper className="team">
                    <CommonTitle>Команда</CommonTitle>
                    <CommonUsualText className="team__text-info">
                        Каждому клиенту мы&nbsp;предоставляем отдельную проектную команду. Над
                        поисковым продвижением МТС Инвестиций работали 5&nbsp;человек с&nbsp;нашей
                        стороны и&nbsp;3&nbsp;человека со&nbsp;стороны заказчика:
                    </CommonUsualText>
                    <CrewContainer container={mtsInvest1} />
                    <CrewContainer container={mtsInvest2} />
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Team;
